import { render, staticRenderFns } from "./PartRoleFeatures.vue?vue&type=template&id=0fb948b7&scoped=true"
import script from "./PartRoleFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./PartRoleFeatures.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PartRoleFeatures.vue?vue&type=style&index=0&id=0fb948b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb948b7",
  null
  
)

export default component.exports